import React from 'react';
import { AssignEmployee } from 'domain/shared/core/dashboard';
import { useStaffingCoordinatorManagement } from '../../hooks/useStaffingCoordinatorManagement';
import { EmployeeLink } from 'domain/shared/employee';

const StaffingDashboardAssignCoordinatorField: React.FC = () => {
  const { assignCallbacks, assigneeOptions, hasChangePermission, currentUserAlias } =
    useStaffingCoordinatorManagement();

  return (
    <AssignEmployee
      assigneeSource="staffingCoordinator"
      entityIdSource="staffingRisk.id"
      employees={assigneeOptions}
      callbacks={assignCallbacks}
      currentUserAlias={currentUserAlias}
      renderAssignee={
        hasChangePermission ? undefined : (alias: string) => <EmployeeLink id={alias} name={alias} isOpenInNewTab />
      }
    />
  );
};

export default StaffingDashboardAssignCoordinatorField;
